// Google Ads conversion tracking helpers.
// Primary conversion: Submit lead form (AW-18400595142/02BDCOug8OQcEMaZi8ZE)
const GOOGLE_ADS_ID = "AW-18400595142";
const LEAD_SEND_TO = `${GOOGLE_ADS_ID}/02BDCOug8OQcEMaZi8ZE`;

const gtagSafe = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    try { window.gtag(...args); } catch (_) {}
  }
};

// Fire the Google Ads Submit-Lead-Form conversion.
export function trackLeadConversion(form = "rfq") {
  gtagSafe("event", "conversion", { send_to: LEAD_SEND_TO, form });
}

// Generic GA4 event (safe no-op if gtag not present).
export function trackEvent(event, params = {}) {
  gtagSafe("event", event, params);
}
